/**
 * List of action names related to Mail compose
 */
export const ACTION_NEW_MESSAGE = 'newMessage';
export const ACTION_REPLY_MESSAGE = 'replyToMessage';
export const ACTION_FORWARD_MESSAGE = 'forwardMessage';
export const ACTION_MAILTO_MESSAGE = 'mailToMessage';
